/* eslint-disable no-case-declarations */
import defaults from "store/defaults";

const UPDATE_STATISTICS_SELF_MESSAGES =
	"global/UPDATE_STATISTICS_SELF_MESSAGES";
const UPDATE_STATISTICS_SELF_NOTIFICATIONS =
	"global/UPDATE_STATISTICS_SELF_NOTIFICATIONS";
const UPDATE_STATISTICS_SELF = "global/UPDATE_STATISTICS_SELF";

const GET_USER_EMAIL = "global/GET_USER_EMAIL";
const GET_USER_EMAIL_SUCCESS = "global/GET_USER_EMAIL_SUCCESS";
const GET_USER_EMAIL_FAIL = "global/GET_USER_EMAIL_FAIL";

const SET_FINGERPRINT = "global/SET_FINGERPRINT";

const SET_PWA_INSTALL_STATUS = "global/SET_PWA_INSTALL_STATUS";

const SET_PWA_INSTALL_EVENT = "global/SET_PWA_INSTALL_EVENT";

const SET_GEOLOCATION = "userpane/data/SET_GEOLOCATION";

const GET_GEOLOCATION_INITIAL_DATA = "global/GET_GEOLOCATION_INITIAL_DATA";
const GET_GEOLOCATION_INITIAL_DATA_SUCCESS =
	"global/GET_GEOLOCATION_INITIAL_DATA_SUCCESS";
const GET_GEOLOCATION_INITIAL_DATA_FAIL =
	"global/GET_GEOLOCATION_INITIAL_DATA_FAIL";

const CLEAR_GEOLOCATION_INITIAL_DATA = "global/CLEAR_GEOLOCATION_INITIAL_DATA";

const SET_FIREBASE_ID = "global/SET_FIREBASE_ID";

const SET_USER_COUNTRY_FROM_IP = "global/SET_USER_COUNTRY_FROM_IP";

const SET_VIEW_TYPE = "global/SET_VIEW_TYPE";

const SET_HOMEPAGE_MEDIA_VIEW_TYPE = "global/SET_HOMEPAGE_MEDIA_VIEW_TYPE";

const initialState = defaults.global;

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case UPDATE_STATISTICS_SELF_MESSAGES:
			return {
				...state,
				statisticsSelf: {
					...state.statisticsSelf,
					messages: action.messages,
				},
			};
		case UPDATE_STATISTICS_SELF_NOTIFICATIONS:
			const newNotifications =
				action.mode === true
					? state.statisticsSelf.notifications + 1
					: action.value;

			return {
				...state,
				statisticsSelf: {
					...state.statisticsSelf,
					notifications: newNotifications,
				},
			};
		case UPDATE_STATISTICS_SELF:
			const newNotificationsSelf =
				action.mode === true
					? state.statisticsSelf.notifications + 1
					: action.notifications === null
					? state.statisticsSelf.notifications
					: action.notifications;
			return {
				...state,
				statisticsSelf: {
					...state.statisticsSelf,
					loaded: true,
					likes: action.userpanel?.likes || 0,
					comments: action.userpanel?.comments || 0,
					invities: action.userpanel?.invities || 0,
					friends: action.userpanel?.friends || 0,
					visitors: action.userpanel?.visitors || 0,
					following: action.userpanel?.following || 0,
					notifications: newNotificationsSelf || 0,
					messages:
						action.messages === null
							? state.statisticsSelf.messages
							: action.messages,
					userStatsHash: action.userStatsHash,
				},
			};
		case GET_USER_EMAIL_SUCCESS:
			return {
				...state,
				user: {
					...state.user,
					email: action.result.data?.email,
				},
			};
		case SET_FINGERPRINT:
			return {
				...state,
				fingerprint: action.fingerprint,
			};

		case SET_PWA_INSTALL_STATUS:
			return {
				...state,
				pwa: {
					...state.pwa,
					status: action.status,
				},
			};
		case SET_PWA_INSTALL_EVENT:
			return {
				...state,
				pwa: {
					...state.pwa,
					event: {
						prompt: action.event.prompt,
						userChoice: action.event.userChoice,
					},
				},
			};

		case SET_GEOLOCATION:
			return {
				...state,
				geolocation: {
					...state.geolocation,
					accuracy: action.geolocation.accuracy,
					latitude: action.geolocation.latitude,
					longitude: action.geolocation.longitude,
					timestamp: action.geolocation.timestamp,
					error: action.geolocation.error,
				},
			};

		case GET_GEOLOCATION_INITIAL_DATA:
			return {
				...state,
				geolocation: {
					...state.geolocation,
					initialData: {
						loading: true,
					},
				},
			};
		case GET_GEOLOCATION_INITIAL_DATA_SUCCESS:
			return {
				...state,
				geolocation: {
					...state.geolocation,
					initialData: {
						loading: false,
						success: true,
						data: {
							city: action.result.data.city || [],
							region: action.result.data.region || [],
							country: action.result.data.country || [],
						},
					},
				},
			};
		case GET_GEOLOCATION_INITIAL_DATA_FAIL:
			return {
				...state,
				geolocation: {
					...state.geolocation,
					initialData: {
						loading: false,
						success: false,
						error: true,
					},
				},
			};
		case CLEAR_GEOLOCATION_INITIAL_DATA:
			return {
				...state,
				geolocation: {
					...state.geolocation,
					initialData: {
						loading: false,
						success: false,
						error: false,
						data: {
							city: [],
							region: [],
							country: [],
						},
					},
				},
			};

		case SET_FIREBASE_ID:
			return {
				...state,
				firebaseId: action.firebaseId,
			};

		case SET_USER_COUNTRY_FROM_IP:
			return {
				...state,
				userCountryFromIp: action.countryId,
			};

		case SET_VIEW_TYPE:
			return {
				...state,
				viewType: action.viewType,
			};

		case SET_HOMEPAGE_MEDIA_VIEW_TYPE:
			return {
				...state,
				homepageMediaType: action.homepageMediaType,
			};

		default:
			return state;
	}
}

export function updateStatisticsSelfMessages(messages) {
	return {
		type: UPDATE_STATISTICS_SELF_MESSAGES,
		messages,
	};
}

export function updateStatisticsSelfNotifications(mode, value = 0) {
	return {
		type: UPDATE_STATISTICS_SELF_NOTIFICATIONS,
		mode,
		value,
	};
}

export function updateStatisticsSelfAuthorized({
	mode,
	userpanel,
	messages = 0,
	notifications = 0,
	userStatsHash,
}) {
	return {
		type: UPDATE_STATISTICS_SELF,
		mode,
		userpanel,
		messages,
		notifications,
		userStatsHash,
	};
}

export function getEmail() {
	return {
		types: [GET_USER_EMAIL, GET_USER_EMAIL_SUCCESS, GET_USER_EMAIL_FAIL],
		promise: (client) => client.get("/user/email"),
	};
}

export function setFingerprint(hash) {
	return {
		type: SET_FINGERPRINT,
		fingerprint: hash,
	};
}

export function setPWAInstallStatus(status) {
	return {
		type: SET_PWA_INSTALL_STATUS,
		status,
	};
}

export function setPWAInstallEvent(event) {
	return {
		type: SET_PWA_INSTALL_EVENT,
		event,
	};
}

export function setGeolocation(geolocation) {
	return {
		type: SET_GEOLOCATION,
		geolocation,
	};
}
export function getGeolocationInitialData(latitude, longitude, extend = true) {
	return {
		types: [
			GET_GEOLOCATION_INITIAL_DATA,
			GET_GEOLOCATION_INITIAL_DATA_SUCCESS,
			GET_GEOLOCATION_INITIAL_DATA_FAIL,
		],
		promise: (client) =>
			client.post(`datezone/autocomplete/coords`, {
				lat: latitude,
				lng: longitude,
				extend,
			}),
	};
}

export function clearGeolocationInitialData() {
	return {
		type: CLEAR_GEOLOCATION_INITIAL_DATA,
	};
}

export function setFirebaseId(fireabseId) {
	return {
		type: SET_FIREBASE_ID,
		fireabseId,
	};
}

export function setUserCountryFromIp(countryId) {
	return {
		type: SET_USER_COUNTRY_FROM_IP,
		countryId,
	};
}

export function setViewType(viewType) {
	return {
		type: SET_VIEW_TYPE,
		viewType,
	};
}

export function setHomepageMediaType(homepageMediaType) {
	return {
		type: SET_HOMEPAGE_MEDIA_VIEW_TYPE,
		homepageMediaType,
	};
}
